import React from "react";
import styles from "./Logos.module.scss";
import { LogosType } from "@/types/OptionType";
import { SVGIcon } from "../../SVGIcon/SVGIcon";
import { passACFLink } from "@/utils/passACFLink";
import { CustomLink } from "@/components/CustomLink";
import useWindowSize from "@/hooks/useWindowSize";

interface LogosProps {
  logos: LogosType[];
  logos_mobile: LogosType[];
  hasBackground: boolean;
  isMobile: boolean;
}

const Logos = React.memo(
  ({ logos, hasBackground, logos_mobile }: LogosProps) => {
    const { width } = useWindowSize();
    const isMobile = width > 0 && width < 768;
    const Logo = ({
      logo,
      className,
      index = 0,
    }: {
      logo: LogosType;
      className?: string;
      index?: number;
    }) => {
      const logoSrc = hasBackground ? logo.logo_negative : logo.logo_positive;
      const logoJSX = logoSrc && (
        <SVGIcon
          width={"auto"}
          height={"100%"}
          src={logoSrc.url}
          priority={true}
          alt={logoSrc.alt}
        />
      );
      return (
        <li
          data-is-small={index > 0}
          className={`${styles["logo"]} ${className ? className : ""}`}
        >
          {logo.link ? (
            <CustomLink
              className={styles["link"]}
              {...passACFLink(logo, "link")}
            >
              {logoJSX}
            </CustomLink>
          ) : (
            logoJSX
          )}
        </li>
      );
    };

    const logosList = isMobile ? logos_mobile : logos;
    return (
      <ul className={styles["logos"]}>
        {logosList.map((logo, key) => {
          return <Logo index={key} key={key} logo={logo} />;
        })}
      </ul>
    );
  },
  (prevProps, nextProps) => {
    // Perform a shallow comparison of the `logos` array
    return (
      prevProps.logos === nextProps.logos &&
      prevProps.hasBackground === nextProps.hasBackground &&
      prevProps.isMobile === nextProps.isMobile
    );
  },
);

Logos.displayName = "Logos";

export { Logos };
